<template>
    <v-container fluid class="main-body">
        <HeaderComponent titulo="I CARRERA POPULAR 7K DEL ROSCÓN"></HeaderComponent>
        <SieteForm></SieteForm>
        <Footer></Footer>
    </v-container>
</template>

<script>
    import HeaderComponent from "@/components/shared/HeaderComponent"
    import SieteForm  from "../components/SieteK";
    import {insService} from "../_services";
    import { limites } from "../config";
    import moment from "moment";
    export default {
        name: "SieteK",
        created() {
            insService.getStatus().then( result => {
                const now = moment()
                const close = moment("2020-01-23")

                if(parseInt(result.data.limites['7K']) >= limites["7K"]) {
                    this.$router.push({ name:'cerrado', params: {
                        titulo: 'I CARRERA POPULAR 7K DEL ROSCÓN' ,
                        mensaje: `Ya no quedan plazas disponibles.`
                    }})
                }
                if(now.isAfter(close)){
                    this.$router.push({ name: 'cerrado', params: {
                        titulo: 'I CARRERA POPULAR 7K DEL ROSCÓN' ,
                        mensaje: `El periódo de inscripción ha finalizado`
                    }})
                }
            })
        },
        components: {SieteForm, HeaderComponent}
    }
</script>

<style scoped lang="scss">
    @import "./../_static/base";
</style>